import React, { Component } from 'react';
import { arrayOf, bool, func, number, object, shape, string } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as skillGeoDifferentialActionCreators from './SkillGeoDifferentialActions';
import {
  cancelEditJobTitle,
  clearAddJobState,
  launchEditJobSlideout,
  editJobTitleSearch,
  getAllReports,
  saveJob,
  selectJob,
  setInitialJobDetails,
  titleJobSearch
} from 'ps-components/Modules/AddJob/reducers/addJob';
import { getJobCerts } from 'ps-components/Modules/AddJob/reducers/jobCertifications';
import * as surveyListActions from 'ps-components/Modules/AddJob/reducers/jobSurveyList';
import Body from 'ps-components/Slideout/Body/SlideoutBody';
import GeoDifferentialCard from './Geo/GeoDifferentialCard';
import SkillDifferentialCard from './Skill/SkillDifferentialCard';
import SkillGeoSlideoutHeader from './Slideout/SkillGeoSlideoutHeader';
import './SkillGeoDifferentialContainer.scss';
import SlideoutFooter from 'ps-components/Slideout/Footer/SlideoutFooter';
import SlideoutFooterStandardButtons from 'ps-components/Slideout/Footer/SlideoutFooterStandardButtons';
import SupportSubmitFailure from 'ps-components/Modules/Support/containers/Form/Submit/SupportSubmitFailure';
import { PRICING_TYPE } from './SkillGeoDifferentialReducer';
import SkillGeoJobMatches from './Slideout/SkillGeoJobMatches';
import SkillGeoComment from './Slideout/SkillGeoComment';
import { withRouter } from 'react-router';
import { getJobByID } from '../JobMatching/OrgJobsActions';
import SuccessTransitionText from 'ps-components/Util/SuccessTransitionText';
import LoadingIndicator from 'ps-components/LoadingIndicator/LoadingIndicator';
import { Alert } from 'ps-design';

const SUBMIT_SUCCESS_TEXT =
  'Thank you for your interest in the Differentials Engine. A PayScale representative will be contacting you shortly.';

export class SkillGeoDifferentialContainer extends Component {
  static propTypes = {
    orgJobId: number,
    orgJobCode: string,
    orgJobCodeKey: string,
    pricingType: string,
    createAdHocJobFailed: bool,
    currency: string,
    jobTitle: string,
    benchmarkYear: number,
    selectedJobPricing: string,
    selectedJobMatches: arrayOf(number),
    hasPerformedCalculateAction: bool,
    isCalculatingProposedValues: bool,
    isSelectingJobMatches: bool,
    comment: string,
    hasChanges: bool,
    includeComment: bool,
    displayIn: string,
    pricingFieldPk: number,
    proposedValues: arrayOf(object),
    hasPreviousDifferential: bool,
    jobPricing: arrayOf(
      shape({
        header: string,
        value: number
      })
    ),
    jobMatches: arrayOf(
      shape({
        matchId: number,
        surveyJobCode: string,
        surveyCode: string,
        slotJobCode: string,
        slotJobCodeKey: string,
        jobScope: string,
        surveyYear: number,
        surveyTitle: string,
        jobTitle: string,
        geo: number,
        adj: number
      })
    ),
    applyingDifferentialsToJobMatches: bool,
    applyingDifferentialsToJobMatchesFailed: bool,
    actions: shape({
      clearGeoDifferential: func,
      getGeoDifferential: func,
      getJobFamilies: func,
      getJobLocations: func,
      toggleGeoCard: func,
      toggleGeoCardExpand: func,
      toggleGeoLocationOnly: func,
      toggleSkillsCard: func,
      toggleSkillsCardExpand: func,
      updateGeoDifferentialOverride: func,
      updateSelectedJobPricing: func,
      updateSkillDifferentialOverride: func,
      applyDifferentialsToJobMatches: func,
      resetDifferentialsToInitialState: func,
      setSelectedJobFamily: func,
      setSelectedJobLocation: func,
      resetGeoState: func,
      setSelectedJobMatches: func,
      setGeoDifferentialIsRemoved: func,
      setSkillsDifferentialIsRemoved: func,
      setComment: func,
      toggleIncludeComment: func,
      calculateProposedValue: func,
      setHasPerformedCalculateAction: func,
      setGeoIsPendingRemove: func,
      setSkillIsPendingRemove: func,
      setHasChanges: func,
      setIncludeComment: func,
      cancelChanges: func,
      setChangesCancelled: func,
      setSelectedSkillGeoDifferentialData: func,
      getJobByID: func,
      clearSubmitRequest: func,
      sendOpportunityEmail: func,
      initDifferentials: func
    }),
    containerClassName: string,
    geo: shape({
      isAdded: bool,
      isExpanded: bool,
      locationOnly: bool,
      jobFamilies: arrayOf(string),
      jobLocations: arrayOf(
        shape({
          locationCity: string,
          locationState: string
        })
      ),
      jobFamiliesLoading: bool,
      differential: number,
      differentialOverride: number,
      differentialLoading: bool,
      differentialFailed: bool,
      selectedJobFamily: string,
      selectedJobLocation: string,
      isRemoved: bool,
      isApplied: bool,
      sampleSize: number,
      isPendingRemove: bool
    }),
    organization: shape({
      useJobCodeKey: bool
    }),
    skills: shape({
      count: number,
      differential: number,
      differentialFailed: bool,
      differentialLoading: bool,
      isAdded: bool,
      isExpanded: bool,
      differentialOverride: number,
      isRemoved: bool,
      isApplied: bool,
      isPendingRemove: bool
    }),
    slideout: shape({
      open: bool
    }),
    hideSlideout: func,
    showGeoDifferential: bool,
    showSkillDifferential: bool,
    refreshJobTabData: func,
    orgCode: string,
    isDifferentialLoaded: bool,
    changesCancelled: bool,
    jobMatchesLoaded: bool,
    defaultBenchmarkYear: number,
    match: object,
    hasInitializedJob: bool,
    isAgingReducerLoaded: bool,
    isLoadingOrgJob: bool,
    submitRequestSuccess: bool,
    submitRequestFailure: bool,
    replacementTokens: arrayOf(
      shape({
        token: string,
        value: string
      })
    ),
    isInitializingDifferentials: bool
  };

  constructor(props) {
    super(props);

    this.state = {
      showAdjustmentApplied: false,
      editingMatches: false,
      previousSelectedJobMatches: [],
      previousIncludeComment: false,
      previousComment: null,
      overlayHeight: 0
    };

    this.applyDifferentialsToJobMatches = this.applyDifferentialsToJobMatches.bind(this);
    this.applyToJob = this.applyToJob.bind(this);
    this.showSelectMatchesSlideout = this.showSelectMatchesSlideout.bind(this);
    this.cancelEditMatches = this.cancelEditMatches.bind(this);
    this.calculateProposedValue = this.calculateProposedValue.bind(this);
    this.submitRequest = this.submitRequest.bind(this);
    this.closeRequestFailure = this.closeRequestFailure.bind(this);
  }

  init() {
    const {
      actions,
      orgJobCode,
      orgJobCodeKey,
      benchmarkYear,
      orgJobId,
      slideout,
      displayIn,
      showSkillDifferential,
      showGeoDifferential
    } = this.props;
    if (slideout.open) {
      const hasFeature = showSkillDifferential || showGeoDifferential;
      actions.initDifferentials(orgJobId, orgJobCode, orgJobCodeKey, benchmarkYear, displayIn, hasFeature);
    }
  }

  initJobToReducer() {
    const {
      actions,
      orgJobCode,
      orgJobCodeKey,
      benchmarkYear,
      defaultBenchmarkYear,
      orgJobId,
      currency,
      displayIn,
      jobTitle,
      match,
      isAgingReducerLoaded,
      isLoadingOrgJob
    } = this.props;

    if (!isAgingReducerLoaded || isLoadingOrgJob) {
      return;
    }
    if (!orgJobId && match.params?.jobId) {
      actions.getJobByID(match.params.jobId).then(job => {
        actions.setSelectedSkillGeoDifferentialData(
          job.id,
          job.code,
          job.codeKey,
          job.currency,
          job.title,
          defaultBenchmarkYear
        );
      });
    } else if (orgJobId && orgJobCode && orgJobCodeKey) {
      actions.setSelectedSkillGeoDifferentialData(
        orgJobId,
        orgJobCode,
        orgJobCodeKey,
        currency,
        jobTitle,
        benchmarkYear || defaultBenchmarkYear,
        displayIn
      );
    }
  }

  componentDidMount() {
    this.initJobToReducer();
  }

  componentDidUpdate(prevProps) {
    const {
      actions,
      slideout,
      applyingDifferentialsToJobMatches,
      applyingDifferentialsToJobMatchesFailed,
      refreshJobTabData,
      hasPerformedCalculateAction,
      changesCancelled,
      hasInitializedJob,
      isAgingReducerLoaded,
      skills,
      geo
    } = this.props;

    if (!hasInitializedJob && isAgingReducerLoaded && slideout.open) {
      this.initJobToReducer();
    }
    if (!slideout.open && prevProps.slideout.open) {
      actions.resetDifferentialsToInitialState();
      if (this.state.editingMatches) {
        this.setState({ editingMatches: false });
        const slideoutBody = document.getElementsByClassName('slideout-body')[0];
        slideoutBody.classList.remove('editing-matches');
      }
    } else if (
      (hasInitializedJob && !prevProps.hasInitializedJob) ||
      (changesCancelled && !prevProps.changesCancelled)
    ) {
      actions.setChangesCancelled(false);
      this.init();
    }
    if (
      !applyingDifferentialsToJobMatches &&
      prevProps.applyingDifferentialsToJobMatches &&
      !applyingDifferentialsToJobMatchesFailed
    ) {
      this.setState({ showAdjustmentApplied: true }, () => {
        if (refreshJobTabData) {
          refreshJobTabData();
        }
      });
      setTimeout(() => {
        this.setState({ showAdjustmentApplied: false });
      }, 2000);
    }
    if (hasPerformedCalculateAction && !prevProps.hasPerformedCalculateAction) {
      actions.setHasPerformedCalculateAction(false);
      this.calculateProposedValue();
    }

    if ((skills.isRemoved && !prevProps.skills.isRemoved) || (geo.isRemoved && !prevProps.geo.isRemoved)) {
      this.applyDifferentialsToJobMatches();
    }
  }

  render() {
    const { showAdjustmentApplied, editingMatches } = this.state;
    const {
      actions,
      addJob,
      currency,
      geo,
      hideSlideout,
      orgJobId,
      jobPricing,
      jobTitle,
      organization,
      orgJobCode,
      orgJobCodeKey,
      selectedJobPricing,
      showGeoDifferential,
      showSkillDifferential,
      skills,
      applyingDifferentialsToJobMatches,
      launchDarklyFeatureFlags,
      pricingType,
      jobMatches,
      selectedJobMatches,
      comment,
      includeComment,
      orgCode,
      pricingFieldPk,
      proposedValues,
      isCalculatingProposedValues,
      displayIn,
      hasChanges,
      hasPreviousDifferential,
      submitRequestSuccess,
      submitRequestFailure,
      slideout,
      replacementTokens,
      isInitializingDifferentials,
      createAdHocJobFailed
    } = this.props;
    const featureIsPurchased = showSkillDifferential || showGeoDifferential;

    return (
      <LoadingIndicator loading={isInitializingDifferentials}>
        <SkillGeoSlideoutHeader
          currency={currency}
          hideSlideout={hideSlideout}
          jobPricing={jobPricing}
          jobTitle={jobTitle}
          orgJobCode={orgJobCode}
          orgJobCodeKey={orgJobCodeKey}
          selectedJobPricing={selectedJobPricing}
          updateSelectedJobPricing={actions.updateSelectedJobPricing}
          useJobCodeKey={organization.useJobCodeKey}
          setHasPerformedCalculateAction={actions.setHasPerformedCalculateAction}
          pricingFieldPk={pricingFieldPk}
          proposedValues={proposedValues}
          isCalculatingProposedValues={isCalculatingProposedValues}
          displayIn={displayIn}
          featureIsPurchased={featureIsPurchased}
          replacementTokens={replacementTokens}
          hideAfterAdjustment={createAdHocJobFailed === true}
        />
        <Body>
          {createAdHocJobFailed && (
            <div className="propose-calc-alert">
              <Alert
                className="pxl-alert-danger"
                message="Proposed composite values can not be calculated at this time. Please try again later or contact support."
                level="danger"
              />
            </div>
          )}
          {(showGeoDifferential || !featureIsPurchased) && (
            <GeoDifferentialCard
              isAdded={geo.isAdded}
              isExpanded={geo.isExpanded}
              locationOnly={geo.locationOnly}
              toggleGeoCard={actions.toggleGeoCard}
              toggleGeoCardExpand={actions.toggleGeoCardExpand}
              toggleGeoLocationOnly={actions.toggleGeoLocationOnly}
              jobFamilies={geo.jobFamilies}
              jobLocations={geo.jobLocations}
              getGeoDifferential={actions.getGeoDifferential}
              getJobFamilies={actions.getJobFamilies}
              jobFamiliesLoading={geo.jobFamiliesLoading}
              differential={geo.differential}
              differentialOverride={geo.differentialOverride}
              updateDifferentialOverride={actions.updateGeoDifferentialOverride}
              differentialLoading={geo.differentialLoading}
              differentialFailed={geo.differentialFailed}
              clearDifferential={actions.clearGeoDifferential}
              selectedJobFamily={geo.selectedJobFamily}
              selectedJobLocation={geo.selectedJobLocation}
              setSelectedJobFamily={actions.setSelectedJobFamily}
              setSelectedJobLocation={actions.setSelectedJobLocation}
              resetGeoState={actions.resetGeoState}
              getJobLocations={actions.getJobLocations}
              isRemoved={geo.isRemoved}
              setGeoDifferentialIsRemoved={actions.setGeoDifferentialIsRemoved}
              pricingType={pricingType}
              isApplied={geo.isApplied}
              sampleSize={geo.sampleSize}
              setIsPendingRemove={actions.setGeoIsPendingRemove}
              isPendingRemove={geo.isPendingRemove}
              disabled={skills.isPendingRemove}
              featureIsPurchased={featureIsPurchased}
            />
          )}
          {(showSkillDifferential || !featureIsPurchased) && (
            <SkillDifferentialCard
              addJob={addJob}
              autoMatchLoading={skills.autoMatchLoading}
              autoMatchLoaded={skills.autoMatchLoaded}
              cancelEditJobTitle={actions.cancelEditMatch}
              editMatch={actions.editMatch}
              skillsError={skills.skillsError}
              isAdded={skills.isAdded}
              isEditing={skills.isEditing}
              isExpanded={skills.isExpanded}
              isInitialLoad={skills.isInitialLoad}
              jobCode={orgJobCode}
              orgJobId={orgJobId}
              orgJobTitle={jobTitle}
              overrideTitle={actions.overrideTitle}
              selectedJobTitle={skills.selectedJobTitle}
              titleJobSearch={actions.titleJobSearch}
              toggleSkillsCard={actions.toggleSkillsCard}
              toggleSkillsCardExpand={actions.toggleSkillsCardExpand}
              skillDifferentialSearch={actions.skillDifferentialSearch}
              toggleSkill={actions.toggleSkill}
              skills={skills.allSkills}
              selectedSkills={skills.selectedSkills}
              skillsLoaded={skills.skillsLoaded}
              differential={skills.differential}
              sampleSize={skills.sampleSize}
              resetSkillsState={actions.resetSkillsState}
              clearAddJobState={actions.clearAddJobState}
              setSelectedJobTitle={actions.setSelectedJobTitle}
              differentialOverride={skills.differentialOverride}
              updateDifferentialOverride={actions.updateSkillDifferentialOverride}
              isPayScaleMatch={skills.isPayScaleMatch}
              isRemoved={skills.isRemoved}
              setSkillsDifferentialIsRemoved={actions.setSkillsDifferentialIsRemoved}
              pricingType={pricingType}
              isApplied={skills.isApplied}
              resetSkillsError={actions.resetSkillsError}
              tasks={skills.tasks}
              setIsPendingRemove={actions.setSkillIsPendingRemove}
              isPendingRemove={skills.isPendingRemove}
              disabled={geo.isPendingRemove}
              showSearch={skills.showSearch}
              toggleSkillsSearch={actions.toggleSkillsSearch}
              featureIsPurchased={featureIsPurchased}
              getJobTasks={actions.getJobTasks}
              slideout={slideout}
            />
          )}
          {editingMatches && <div className="editing-matches__overlay" style={{ height: this.state.overlayHeight }} />}
        </Body>
        <SlideoutFooter isBoxShadowTheme={true}>
          {submitRequestSuccess ? (
            <div className="differential__trial-success-message">
              <div className="differential__trial-success icon-reverse icon-circle">
                <i className="icon-check" />
              </div>
              <p className="success__text">{SUBMIT_SUCCESS_TEXT}</p>
            </div>
          ) : (
            <>
              <div className="footer__text">{this.renderFooterText()}</div>
              <div className="footer__right">
                <SuccessTransitionText
                  isHidden={!editingMatches}
                  text="Adjustment Applied"
                  isLoadingComplete={showAdjustmentApplied}
                >
                  <div className="footer__actions">
                    {!featureIsPurchased && (
                      <SlideoutFooterStandardButtons
                        applyText="Learn More"
                        doApply={this.submitRequest}
                        doCancel={actions.cancelChanges}
                        showCancel={hasChanges}
                        applyClassName="not-purchased"
                      />
                    )}
                    {!editingMatches && !geo.isPendingRemove && !skills.isPendingRemove && featureIsPurchased && (
                      <SlideoutFooterStandardButtons
                        applyText={`Next: Select ${
                          pricingType === PRICING_TYPE.SLOTTED ? 'Slotted' : 'Survey'
                        } Job Matches`}
                        doApply={this.showSelectMatchesSlideout}
                        doCancel={actions.cancelChanges}
                        showCancel={hasChanges}
                        isApplyDisabled={
                          !this.hasDifferentialsToApply() ||
                          skills.isPendingRemove ||
                          geo.isPendingRemove ||
                          jobMatches.length === 0
                        }
                      />
                    )}
                    {editingMatches && (
                      <SlideoutFooterStandardButtons
                        applyText={
                          applyingDifferentialsToJobMatches || showAdjustmentApplied ? (
                            <i className="icon-animate-spin icon-spin"></i>
                          ) : (
                            <>{hasPreviousDifferential ? 'Update' : 'Apply to Job'}</>
                          )
                        }
                        doApply={this.applyToJob}
                        doCancel={this.cancelEditMatches}
                        isApplyDisabled={selectedJobMatches.length === 0 || this.isJobFromDifferentBenchmarkYear()}
                      />
                    )}
                  </div>
                </SuccessTransitionText>
              </div>
            </>
          )}
        </SlideoutFooter>
        <div className="edit-job-match__container">
          <div className="job-select__container">
            {jobMatches && jobMatches.length > 0 && (
              <SkillGeoJobMatches
                jobMatches={jobMatches}
                selectedJobMatches={selectedJobMatches}
                setSelectedJobMatches={actions.setSelectedJobMatches}
                pricingType={pricingType}
              />
            )}
          </div>
          <div className="job-comments__container">
            <SkillGeoComment
              comment={comment}
              includeComment={includeComment}
              toggleIncludeComment={actions.toggleIncludeComment}
              setComment={actions.setComment}
              geoDifferential={geo.differentialOverride || geo.differential}
              skillDifferential={skills.differentialOverride || skills.differential}
              hasChanges={hasChanges}
            />
          </div>
        </div>
        {submitRequestFailure && <SupportSubmitFailure doClose={this.closeRequestFailure} />}
      </LoadingIndicator>
    );
  }

  closeRequestFailure() {
    this.props.actions.clearSubmitRequest();
  }

  submitRequest() {
    this.props.actions.sendOpportunityEmail();
  }

  isJobFromDifferentBenchmarkYear() {
    const { benchmarkYear, defaultBenchmarkYear } = this.props;
    return benchmarkYear && defaultBenchmarkYear && benchmarkYear !== defaultBenchmarkYear;
  }

  renderFooterText() {
    const { jobMatchesLoaded, jobMatches, showSkillDifferential, showGeoDifferential } = this.props;
    const { editingMatches } = this.state;

    const featureIsPurchased = showSkillDifferential || showGeoDifferential;

    if (!featureIsPurchased) {
      return this.renderNotPurchasedMessage();
    }

    if (!jobMatchesLoaded) {
      return;
    }

    if (this.isJobFromDifferentBenchmarkYear()) {
      return this.renderBenchmarkYearError();
    }

    if (!jobMatches.length) {
      return this.renderPricingError();
    }

    if (editingMatches) {
      return (
        <>
          {this.renderApplyMessage()}
          <span className="selected-job-matches__label">{this.renderSelectedJobMessage()}</span>
        </>
      );
    }
  }

  renderNotPurchasedMessage() {
    return (
      <div className="differential__trial-message">
        <p className="primary__text">
          You are currently previewing the Skill/Geo Differential for a specified job title.
        </p>
        <p className="secondary__text">
          Contact your Client Success Manager to learn more or to enable this feature on your site.
        </p>
      </div>
    );
  }

  renderPricingError() {
    return this.renderError('To apply differential, please price this job first.');
  }

  renderBenchmarkYearError() {
    return this.renderError('Differentials can only be applied to the default benchmark year');
  }

  renderError(message) {
    return (
      <div className="differential__warning-message">
        <i className="icon-warning" />
        <p className="differential__warning-text">{message}</p>
      </div>
    );
  }

  renderApplyMessage() {
    let differentialsText = '';
    if (this.hasSkillsDifferentialToApply()) {
      differentialsText += ' Skill';
    }
    if (this.hasSkillsDifferentialToApply() && this.hasGeoDifferentialToApply()) {
      differentialsText += ' &';
    }
    if (this.hasGeoDifferentialToApply()) {
      differentialsText += ' Geo';
    }
    return (
      <>
        Apply<span className="applied-differentials__label"> {differentialsText}</span> Differential to{' '}
      </>
    );
  }

  renderSelectedJobMessage() {
    const { pricingType, selectedJobMatches, jobMatches } = this.props;
    if (pricingType === PRICING_TYPE.PRICED) {
      if (selectedJobMatches.length === jobMatches.length) {
        return 'All Survey Job Matches';
      }
      return `${selectedJobMatches.length} Survey Job Matches`;
    } else if (pricingType === PRICING_TYPE.SLOTTED) {
      if (selectedJobMatches.length === jobMatches.length) {
        return 'All Slotted Jobs';
      }
      return `${selectedJobMatches.length} Slotted Job Matches`;
    }
  }

  showSelectMatchesSlideout() {
    const { selectedJobMatches, includeComment, comment } = this.props;
    const slideoutBody = document.getElementsByClassName('slideout-body')[0];
    if (!slideoutBody) {
      return;
    }
    slideoutBody.classList.add('editing-matches');
    this.setState({
      editingMatches: true,
      previousSelectedJobMatches: [...selectedJobMatches],
      previousIncludeComment: includeComment,
      previousComment: comment,
      overlayHeight: slideoutBody.scrollHeight + 'px'
    });
  }

  applyToJob() {
    const { actions } = this.props;
    this.applyDifferentialsToJobMatches().then(() => {
      setTimeout(() => {
        actions.setHasChanges(false);
        this.closeEditMatches();
      }, 750);
    });
  }

  cancelEditMatches() {
    const { previousSelectedJobMatches, previousIncludeComment, previousComment } = this.state;
    const { actions } = this.props;
    actions.setSelectedJobMatches(previousSelectedJobMatches);
    actions.setIncludeComment(previousIncludeComment);
    actions.setComment(previousComment);
    this.closeEditMatches();
  }

  closeEditMatches() {
    const slideoutBody = document.getElementsByClassName('slideout-body')[0];
    if (!slideoutBody) {
      return;
    }
    this.setState({ editingMatches: false });
    slideoutBody.classList.remove('editing-matches');
  }

  calculateProposedValue() {
    const {
      actions,
      geo,
      skills,
      orgJobId,
      selectedJobMatches,
      jobMatches,
      jobPricing,
      displayIn,
      benchmarkYear
    } = this.props;
    let geoDifferential;
    let skillDifferential;
    if (geo.isRemoved || geo.isPendingRemove) {
      geoDifferential = 0.0;
    } else {
      geoDifferential = isNaN(geo.differentialOverride) ? geo.differential : geo.differentialOverride;
    }
    if (skills.isRemoved || skills.isPendingRemove) {
      skillDifferential = 0.0;
    } else {
      skillDifferential = isNaN(skills.differentialOverride) ? skills.differential : skills.differentialOverride;
    }

    const jobPricingFieldPks = jobPricing?.map(pricing => pricing.field.field_pk);
    actions.calculateProposedValue(
      orgJobId,
      jobMatches,
      selectedJobMatches,
      geoDifferential,
      skillDifferential,
      jobPricingFieldPks,
      displayIn,
      benchmarkYear
    );
  }

  applyDifferentialsToJobMatches() {
    const {
      actions,
      geo,
      skills,
      orgJobId,
      orgJobCode,
      orgJobCodeKey,
      selectedJobMatches,
      benchmarkYear,
      includeComment,
      comment,
      displayIn,
      jobMatches
    } = this.props;

    const geoDifferential = geo.differentialOverride ? geo.differentialOverride : geo.differential;
    const skillDifferential = skills.differentialOverride ? skills.differentialOverride : skills.differential;

    const availableMatchIds = jobMatches.map(match => match.matchId);
    const filteredMatchIds = selectedJobMatches.filter(matchId => availableMatchIds.includes(matchId));

    return actions.applyDifferentialsToJobMatches(
      orgJobId,
      orgJobCode,
      orgJobCodeKey,
      benchmarkYear,
      filteredMatchIds,
      geoDifferential,
      skillDifferential,
      geo.selectedJobLocation,
      geo.selectedJobFamily,
      skills.selectedSkills,
      includeComment ? comment : null,
      skills.selectedJobTitle,
      displayIn
    );
  }

  hasGeoDifferentialToApply() {
    const { geo } = this.props;
    return (
      (!isNaN(geo.differentialOverride) && geo.differentialOverride !== null) ||
      (!isNaN(geo.differential) && geo.differential !== null)
    );
  }

  hasSkillsDifferentialToApply() {
    const { skills } = this.props;
    return (
      (!isNaN(skills.differentialOverride) && skills.differentialOverride !== null) ||
      (!isNaN(skills.differential) && skills.differential !== null)
    );
  }

  hasDifferentialsToApply() {
    return this.hasGeoDifferentialToApply() || this.hasSkillsDifferentialToApply();
  }
}

const mapStateToProps = ({
  jobDetails,
  session,
  skillGeoDifferential,
  addJob,
  jobSurveyList,
  config,
  aging,
  slideout,
  orgJobs
}) => {
  return {
    ...skillGeoDifferential,
    organization: session.organization,
    orgCode: config.orgCode,
    addJob,
    jobDetails,
    jobSurveyList,
    defaultBenchmarkYear: aging.benchmarkYear,
    ...slideout.slideoutProps,
    replacementTokens: session.replacementTokens,
    showSkillDifferential: session.organization?.accountMetaData?.skillDifferentials || false,
    showGeoDifferential: session.organization?.accountMetaData?.geoDifferentials || false,
    isAgingReducerLoaded: aging.loaded,
    isLoadingOrgJob: orgJobs.isLoading
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...skillGeoDifferentialActionCreators,
      titleJobSearch,
      saveJob,
      selectJob,
      setInitialJobDetails,
      getAllReports,
      getJobCerts,
      launchEditJobSlideout,
      editJobTitleSearch,
      cancelEditJobTitle,
      ...surveyListActions,
      clearAddJobState,
      getJobByID
    },
    dispatch
  )
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SkillGeoDifferentialContainer));
